import '.f0{font-size:1.125rem;}.ssr-plugin'
import '.e4{line-height:1.75rem;}.ssr-plugin'
import '.c0{text-decoration:none;}.ssr-plugin'
import '.i0{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="f0 e4"
    >
      {translations.privacySubtitle}{' '}
      <a className="c0 i0"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="c0 i0"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
